module.exports = __webpack_public_path__ + "kuwait.svg?34bc2795883905c5d13cae21e08c9dd0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/kuwait.svg
// module id = 207
// module chunks = 10